import React from 'react';
import {InertiaLink, usePage} from "@inertiajs/inertia-react";
import Layout from "@/Shared/Layout";

const PublishingMerchants = () => {
  const {merchant} = usePage().props
  console.log('PublishingMerchants', merchant)

  return (
    <div>
      <h1 className="mb-8 text-3xl font-bold">
        <InertiaLink
          href={route('added.merchants')}
          className="text-indigo-600 hover:text-indigo-700"
        >
          Added Merchants
        </InertiaLink>
        <span className="font-medium text-indigo-600"> /</span> Merchant Publication
      </h1>
    </div>
  );
};

PublishingMerchants.layout = page => <Layout title="Merchant Publication" children={page}/>;

export default PublishingMerchants;
